import script from "./AddressBlockTonSkeleton.vue?vue&type=script&setup=true&lang=js"
export * from "./AddressBlockTonSkeleton.vue?vue&type=script&setup=true&lang=js"

import "./AddressBlockTonSkeleton.vue?vue&type=style&index=0&id=0148a889&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0148a889"]])

export default __exports__